import angular from 'angular';
import ProductsPageToolboxDirective from './products-page-toolbox.directive';

let ProductsPageToolboxModule = angular.module('catalog.productsList.productsPageToolbox', [])
 .directive('productsPageToolbox', ProductsPageToolboxDirective);

export default ProductsPageToolboxModule;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/products-list/products-page-toolbox/products-page-toolbox.js
 **/